<i class="fa fa-tag" (click)="open(content)" container="body"></i>
<!-- モーダル -->
<ng-template #content let-modal>
  <div class="modal-body" (keydown)="EnterOnRegister($event)">
    <h3 class="modal-title">ボタン登録</h3>
    <input class="form-control" placeholder="JAVA" [(ngModel)]="name" />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary-dark" [ngClass]="{'btn-disabled': !(name?.length > 0)}"
      (click)="registerTag()" [disabled]="!(name?.length > 0)">
      登録
    </button>
  </div>
</ng-template>